import { useState } from 'preact/hooks';

/**
 * Swiss canton crest. Cantons ship as SVGs under /cantons/<code>.svg.
 * Renders nothing visible (an empty spacer) if the code is unknown/missing so
 * leaderboard rows and profiles don't break on users without a canton set.
 */
export function CantonShield({ code, size = 18 }: { code?: string; size?: number }) {
  const [broken, setBroken] = useState(false);
  if (!code || broken) return null;
  return (
    <img
      class="bc-canton"
      src={`/cantons/${code.toLowerCase()}.svg`}
      alt={code.toUpperCase()}
      title={code.toUpperCase()}
      width={size}
      height={size}
      onError={() => setBroken(true)}
    />
  );
}
